<template>
  <v-container id="sistemas" fluid tag="section">
    <base-material-card
      color="primary"
      icon="mdi-animation"
      inline
      class="px-5 py-3"
      :title="$t('systems')"
    >
      <v-spacer></v-spacer>

      <template v-slot:after-heading></template>

      <!-- Boton nuevo registro -->
      <template v-slot:corner-button>
        <v-btn small class="ma-2" elevation="2" color="primary" @click.stop="dialog = true"
          >Nuevo Sistema</v-btn
        >
      </template>

      <!-- Overlay para retroalimentar al usuario -->
      <v-overlay :value="overlay">
        <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
      </v-overlay>

      <!-- Barra de Búsqueda -->
      <v-text-field
        append-icon="mdi-magnify"
        class="ml-auto"
        hide-details
        label="Búsqueda"
        single-line
        style="max-width: 250px"
        v-model="search"
      />

      <!-- Empieza Dialogo Cancelar -->
      <ConfirmationDialog
        buttonColor1="red"
        buttonText1="NO"
        buttonColor2="primary"
        buttonText2="SI"
        text="Seguro quiere cancelar?"
        title="¡Se perderan todos los cambios!"
        v-model="isSure"
        :width="420"
        @click="cancel"
      />

      <!-- Dialogo Agregar/Editar Sistema -->
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <!-- <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title> -->

          <v-card-text>
            <base-subheading :subheading="formTitle" />
            <v-container>
              <v-row>
                <!-- Nombre del sistema -->
                <v-col cols="12">
                  <v-text-field
                    dense
                    label="Sistema*"
                    hint="Nombre del sistema"
                    maxlength="30"
                    required
                    v-model="$v.editedItem.sistema.$model"
                    :error-messages="sistemaErrors"
                    @blur="$v.editedItem.sistema.$touch()"
                    @change="onTextChange"
                    @input="$v.editedItem.sistema.$reset()"
                  ></v-text-field>
                </v-col>
                <!-- Descripción del sistema -->
                <v-col cols="12">
                  <v-text-field
                    counter="50"
                    dense
                    hint="Descripción de la función del sistema"
                    label="Descripción*"
                    maxlength="50"
                    required
                    v-model="$v.editedItem.descripcion.$model"
                    :error-messages="descripcionErrors"
                    @blur="$v.editedItem.descripcion.$touch()"
                    @change="onTextChange"
                    @input="$v.editedItem.descripcion.$reset()"
                  ></v-text-field>
                </v-col>
                <!-- Etiqueta sistema -->
                <v-col cols="12">
                  <v-text-field
                    dense
                    hint="Etiqueta para mostrar en el drawer con el nombre del sistema, debera existir en los archivos de locales"
                    label="Etiqueta*"
                    maxlength="20"
                    required
                    v-model="$v.editedItem.titulo.$model"
                    :error-messages="tituloErrors"
                    @blur="$v.editedItem.titulo.$touch()"
                    @change="onTextChange"
                    @input="$v.editedItem.titulo.$reset()"
                  ></v-text-field>
                </v-col>
                <!-- Ruta del sistema -->
                <v-col cols="6">
                  <v-text-field
                    dense
                    hint="Ruta del sistema para el ruteador"
                    label="Ruta*"
                    maxlength="20"
                    required
                    v-model="$v.editedItem.to.$model"
                    :error-messages="rutaErrors"
                    @blur="$v.editedItem.to.$touch()"
                    @change="onTextChange"
                    @input="$v.editedItem.to.$reset()"
                  ></v-text-field>
                </v-col>
                <!-- Icono del sistema -->
                <v-col cols="6">
                  <v-text-field
                    dense
                    hint="Ícono del sistema que aparece en el drawer, solo para primer nivel de menú"
                    label="Icono*"
                    maxlength="30"
                    required
                    v-model="$v.editedItem.icono.$model"
                    :error-messages="iconoErrors"
                    @blur="$v.editedItem.icono.$touch()"
                    @change="onTextChange"
                    @input="$v.editedItem.icono.$reset()"
                    style="width: 250px"
                    :append-icon="editedItem.icono"
                  ></v-text-field>
                </v-col>
                <!-- <v-col cols="1">
                  <span class="group pa-2">
                    <v-icon large color="primary">{{ editedItem.icono }}</v-icon>
                  </span>
                </v-col> -->
              </v-row>
            </v-container>
            <small>*Campo Obligatorio</small>
          </v-card-text>

          <!-- Botones y CheckList -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-checkbox
              v-if="editedIndex === -1"
              v-model="checkbox"
              label="Crear otro"
              :disabled="isEditing"
            ></v-checkbox>

            <v-btn color="error" text @click="checkChanges">Cancelar</v-btn>
            <v-btn color="primary" text @click="save" :disabled="$v.$invalid">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-divider class="mt-3" />

      <!-- Tabla de Sistemas -->
      <v-data-table
        dense
        item-key="_id"
        loading-text="Cargando... Espere por favor"
        :headers="headers"
        :items="sistemas"
        :items-per-page="10"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100],
        }"
        :loading="isLoading"
        :search.sync="search"
      >
        <template v-slot:item.icono="{ item }">
          <v-icon left medium class="mr-2" color="primary">{{ item.icono }}</v-icon>
          <p>{{ item.icono }}</p>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>

        <!-- Creo el boton de Activo-->
        <template v-slot:item.activo="{ item }">
          <Status :activo="item.activo" />
        </template>
        <template v-slot:no-data
          ><!-- <v-btn color="primary">Reset</v-btn> -->
          ¡No hay datos para mostrar!</template
        >
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

import ConfirmationDialog from '@/components/general/ConfirmationDialog.vue'
import Status from '@/components/general/StatusInfo.vue'

export default {
  components: {
    Status,
    ConfirmationDialog,
  },

  data: () => ({
    changed: false,
    checkbox: false,
    dialog: false,
    editedIndex: -1,
    isLoading: false,
    isEditing: false,
    isSure: false,
    overlay: false,
    search: undefined,
    headers: [
      { text: 'Sistema', align: 'start', sortable: false, value: 'sistema' },
      { text: 'Descripción', value: 'descripcion' },
      { text: 'Titulo', value: 'titulo' },
      { text: 'Ruta', value: 'to' },
      { text: 'Icono', value: 'icono' },
      { text: 'Activo', value: 'activo' },
      { text: 'Acciones', value: 'actions', sortable: false },
    ],
    sistemas: [],
    value: [],
    editedItem: {
      sistema: '',
      descripcion: '',
      to: '',
      icono: '',
      titulo: '',
      activo: true,
    },
    defaultItem: {
      sistema: '',
      descripcion: '',
      to: '',
      icono: '',
      titulo: '',
      activo: true,
    },
  }),

  mixins: [validationMixin],
  //Validaciones para los campos del formulario
  validations: {
    editedItem: {
      sistema: { required, minLength: minLength(3), maxLength: maxLength(20) },
      descripcion: { required, minLength: minLength(3), maxLength: maxLength(50) },
      to: { required, minLength: minLength(3), maxLength: maxLength(50) },
      icono: { required, minLength: minLength(3), maxLength: maxLength(50) },
      titulo: { required, minLength: minLength(3), maxLength: maxLength(50) },
    },
  },

  computed: {
    //Titulo de los formularios
    formTitle() {
      return this.editedIndex === -1 ? 'Nuevo Sistema' : 'Editar Sistema'
    },

    sistemaErrors() {
      const errors = []
      if (!this.$v.editedItem.sistema.$dirty) return errors
      !this.$v.editedItem.sistema.required && errors.push('Este campo es requerido')
      !this.$v.editedItem.sistema.minLength &&
        errors.push('Este campo debe de tener un mínimo de 3 caracteres.')
      !this.$v.editedItem.sistema.maxLength &&
        errors.push('Este campo debe de tener un máximo de 20 caracteres.')
      return errors
    },
    descripcionErrors() {
      const errors = []
      if (!this.$v.editedItem.descripcion.$dirty) return errors
      !this.$v.editedItem.descripcion.required && errors.push('Este campo es requerido')
      !this.$v.editedItem.descripcion.minLength &&
        errors.push('Este campo debe de tener un mínimo de 3 caracteres.')
      !this.$v.editedItem.descripcion.maxLength &&
        errors.push('Este campo debe de tener un máximo de 50 caracteres.')
      return errors
    },
    rutaErrors() {
      const errors = []
      if (!this.$v.editedItem.to.$dirty) return errors
      !this.$v.editedItem.to.required && errors.push('Este campo es requerido')
      !this.$v.editedItem.to.minLength &&
        errors.push('Este campo debe de tener un mínimo de 3 caracteres.')
      !this.$v.editedItem.to.maxLength &&
        errors.push('Este campo debe de tener un máximo de 50 caracteres.')
      return errors
    },
    iconoErrors() {
      const errors = []
      if (!this.$v.editedItem.icono.$dirty) return errors
      !this.$v.editedItem.icono.required && errors.push('Este campo es requerido')
      !this.$v.editedItem.icono.minLength &&
        errors.push('Este campo debe de tener un mínimo de 3 caracteres.')
      !this.$v.editedItem.icono.maxLength &&
        errors.push('Este campo debe de tener un máximo de 50 caracteres.')
      return errors
    },
    tituloErrors() {
      const errors = []
      if (!this.$v.editedItem.titulo.$dirty) return errors
      !this.$v.editedItem.titulo.required && errors.push('Este campo es requerido')
      !this.$v.editedItem.titulo.minLength &&
        errors.push('Este campo debe de tener un mínimo de 3 caracteres.')
      !this.$v.editedItem.titulo.maxLength &&
        errors.push('Este campo debe de tener un máximo de 50 caracteres.')
      return errors
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
  },

  created() {
    this.obtenerSistemas()
  },

  methods: {
    /**
     * @description Borrar en BD no funciona por el momento
     */
    async BorrarRegistro() {
      this.overlay = true
      this.$v.$touch()

      let body = {
        _id: this.editedItem._id,
      }
      let payload = { body: body }
      payload.id = this.editedItem._id
      this.$store
        .dispatch('system/deleteSystem', payload)
        .then(() => {
          this.$store.commit('ALERT', {
            color: 'success',
            text: 'El registro se eliminó con éxito',
          })
          this.overlay = false
        })
        .catch((err) => {
          this.$store.commit('ALERT', {
            color: 'error',
            text: err.response.data.msg,
            // Enviar a inicio de sesión
          })
          this.overlay = false
        })
      this.editedItem = Object.assign({}, this.defaultItem)
    },

    /**
     * @description Verifica si esta seguro de salir del dialogo
     */
    cancel(isSure) {
      this.isSure = isSure
      if (this.isSure) {
        this.close(false)
        this.changed = false
      }
    },

    /**
     * @description Verifica si cambio algun campo
     */
    checkChanges() {
      if (this.changed) {
        this.isSure = true
      } else {
        this.close(false)
        this.changed = false
      }
    },

    /**
     * @description Cierra el dialogo
     * @param {bool} checkbox boleano que indica el estado del checkbox
     */
    close(checkbox) {
      this.isSure = false
      this.changed = false
      this.checkbox = checkbox
      if (!this.checkbox) {
        this.dialog = false
      }
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
      this.$v.$reset()
    },

    /**
     * @description Elimina un sistema
     * @param {object} item elemento seleccionado
     */
    deleteItem(item) {
      const index = this.sistemas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      //Confirma cerrar formulario
      if (confirm('Esta seguro que desea eliminar este registro?')) {
        this.BorrarRegistro()
        this.sistemas.splice(index, 1)
      }
    },

    /**
     * @description Obtiene el indice del elemento seleccionado y lo asigna al array editedItem
     * @param {object} item elemento seleccionado
     */
    editItem(item) {
      this.isEditing = true
      this.editedIndex = this.sistemas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    /**
     * @description Obtiene un listado de sistemas
     * @return {array} arreglo con todaos los sistemas
     */
    async obtenerSistemas() {
      this.isLoading = true
      let payload = {}
      this.$store
        .dispatch('system/fetchSystems', payload)
        .then((response) => {
          this.sistemas = response.data
          this.isLoading = false
        })
        .catch((err) => {
          this.isLoading = false
          this.$store.commit('ALERT', {
            color: 'error',
            text: err.response.data.error,
            // Enviar a inicio de sesión
          })
        })
    },

    /**
     * @description Marca que ha cambiado el valor de un campo
     */
    onTextChange() {
      this.changed = true
    },

    /**
     * @description Guarda el contenido del dialogo ya sea para un sistema nuevo o
     * la edicion de un sistema
     */
    async save() {
      this.overlay = true
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let body = {
          sistema: this.editedItem.sistema,
          descripcion: this.editedItem.descripcion,
          to: this.editedItem.to,
          icono: this.editedItem.icono,
          titulo: this.editedItem.titulo,
        }
        let payload = { body: body }
        if (this.editedIndex > -1) {
          payload.id = this.editedItem._id
          this.$store
            .dispatch('system/editSystem', payload)
            .then(() => {
              this.$store.commit('ALERT', {
                color: 'success',
                text: 'El registro se actualizo con éxito',
              })
              this.overlay = false
            })
            .catch((err) => {
              this.$store.commit('ALERT', {
                color: 'error',
                text: err.response.data.error,
                // Enviar a inicio de sesión
              })
              this.overlay = false
            })
          Object.assign(this.sistemas[this.editedIndex], this.editedItem)
        } else {
          this.$store
            .dispatch('system/addSystem', payload)
            .then((response) => {
              this.$store.commit('ALERT', {
                color: 'success',
                text: 'El registro se creó con éxito',
              })
              this.sistemas.push(response.data)
              this.overlay = false
            })
            .catch((err) => {
              this.$store.commit('ALERT', {
                color: 'error',
                text: err.response.data.error,
                // Enviar a inicio de sesión
              })
              this.overlay = false
            })
        }
        this.close(this.checkbox)
      }
    },
  },
}
</script>
